/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrClaimSocialLikeBody
 */
export interface RttrClaimSocialLikeBody {
    /**
     * Full URL of the social post being claimed. Server normalizes (lowercases host, trims trailing slash, strips query) before storage so equivalent URL variants collapse to one claim.
     * @type {string}
     * @memberof RttrClaimSocialLikeBody
     */
    postUrl: string;
    /**
     * The objective being claimed. Its socialPolicy supplies the accepted platforms and, when the brand has named them, the specific posts a like must match.
     * @type {string}
     * @memberof RttrClaimSocialLikeBody
     */
    objectiveTemplateId?: string;
}

/**
 * Check if a given object implements the RttrClaimSocialLikeBody interface.
 */
export function instanceOfRttrClaimSocialLikeBody(value: object): value is RttrClaimSocialLikeBody {
    if (!('postUrl' in value) || value['postUrl'] === undefined) return false;
    return true;
}

export function RttrClaimSocialLikeBodyFromJSON(json: any): RttrClaimSocialLikeBody {
    return RttrClaimSocialLikeBodyFromJSONTyped(json, false);
}

export function RttrClaimSocialLikeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrClaimSocialLikeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'postUrl': json['postUrl'],
        'objectiveTemplateId': json['objectiveTemplateId'] == null ? undefined : json['objectiveTemplateId'],
    };
}

export function RttrClaimSocialLikeBodyToJSON(json: any): RttrClaimSocialLikeBody {
    return RttrClaimSocialLikeBodyToJSONTyped(json, false);
}

export function RttrClaimSocialLikeBodyToJSONTyped(value?: RttrClaimSocialLikeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'postUrl': value['postUrl'],
        'objectiveTemplateId': value['objectiveTemplateId'],
    };
}

